module.exports = __webpack_public_path__ + "static/media/logo-greener.254d21eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/logo-greener.png
// module id = 1904
// module chunks = 0